import { render } from "./TagMatchTypeToggle.vue?vue&type=template&id=76983dfb&scoped=true"
import script from "./TagMatchTypeToggle.vue?vue&type=script&lang=js"
export * from "./TagMatchTypeToggle.vue?vue&type=script&lang=js"

import "./TagMatchTypeToggle.vue?vue&type=style&index=0&id=76983dfb&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76983dfb"]])

export default __exports__